<template>
	<div class="justify-between" :class="cardSize" ref="card">
		<div :class="[
			'p-2 flex flex-col leading-normal',
			index === 0 ? cardClass + ' rounded-t' :
				index === lastIndex ? cardClass + ' rounded-b' :
					cardClass
		]">
			<div class="grid sm:grid-cols-[auto_1fr] gap-4 items-start" id="inside-card">
				<!-- Imagen del producto -->
				<div class="flex justify-center w-full">
					<div id="img-box">
						<img :src="imageSrc" loading="lazy" class="img-responsive product-image rounded"
							@error="$event.target.src = altImageSrc" width="105" height="auto"
							oncontextmenu="return false" role="button"
							@click="$functions.modals.openProductModal($axios, $apiRoute, content.barra, imageSrc, altImageSrc)" />
					</div>
				</div>

				<!-- Información del producto -->
				<div class="flex flex-col gap-3 w-full">
					<!-- Primera fila: input y descripción -->
					<div class="flex flex-col md:grid md:grid-cols-[1fr_6fr] md:gap-4">
						<!-- Input + botón -->
						<cart-input :type="number" v-model="inputValue" :value="localContent.quantity"
							@add-to-cart="handleCart" text="Agregar al carrito" :content="localContent"
							@quality="updateValue"
							:icon="['bx', 'bxs-cart-add', animate ? 'bx-fade-right bx-flip-horizontal' : '']"
							:hasDiscount="localContent.discount" :hasNewCost="false"  @sedes-status="handleSedesStatus"  />

						<div class="flex flex-col md:grid md:grid-cols-[2fr_2fr_1fr] md:gap-4">
							<!-- Descripción -->
							<div class="flex flex-col">
								<span class="text-xs font-medium text-slate-700">DESCRIPCIÓN:</span>
								<p class="font-bold text-xs sm:text-sm flex items-center">
									<i class="bx bxs-capsule mr-1"></i>{{ truncatedValue(title) }} - {{
										localContent.codprod }}
								</p>
							</div>

							<!-- Molécula -->
							<div class="flex flex-col">
								<span class="text-xs font-medium text-slate-700">MOLÉCULA:</span>
								<p class="font-bold text-xs sm:text-sm flex items-center">
									<i class="bx bx-dna mr-1"></i>{{ truncatedValue(localContent.molecula) }}
								</p>
							</div>

							<!-- Unidad molécula -->
							<div class="flex flex-col">
								<span class="text-xs font-medium text-slate-700">UNIDAD MOLÉCULA:</span>
								<p class="font-bold text-xs sm:text-sm flex items-center">
									<i class="bx bx-shape-triangle mr-1"></i>{{ localContent?.dataprod?.unidadmolecula
										|| 1 }}
								</p>
							</div>
						</div>
					</div>

					<!-- Fila de etiquetas -->
					<div class="grid grid-cols-2 gap-4" v-if="hayEtiquetasActivas">
						<div class="grid grid-cols-4 gap-2">
							<span v-if="(100 - content.total_indexado) > 0 && content.desc_indexados"
								class="badge bg-sky-500" v-tooltip="{
									content: $functions.tooltips.indexedDiscounts(localContent),
									html: true,
									position: 'left',
									autoHide: true,
									triggers: ['hover']
								}" role="button">
								DI <i class="bx bx-tag ml-1"></i>
							</span>

							<span v-if="localContent.iva > 0" class="badge bg-sky-400"
								v-tooltip="'Porcentaje de IVA agregado'">
								+{{ localContent.iva }}% IVA
							</span>

							<span v-if="localContent.discountMarca > 0" class="badge bg-sky-500"
								v-tooltip="'Descuento por marca'">
								+{{ localContent.discountMarca }}% DN
							</span>

							<span v-if="localContent.discountItem > 0" class="badge bg-sky-500"
								v-tooltip="'Descuento por producto'">
								+{{ localContent.discountItem }}% DP
							</span>
						</div>
					</div>

					<!-- Componente hijo ProductoInfo -->
					<ProductoInfo :title="localTitle" :content="localContent" :cardClass="localCardClass"
						:cardSize="cardSize" :headerClass="localHeaderClass" :index="localIndex" :lastIndex="lastIndex"
						type="2" :user="user" />
				</div>
			</div>
		</div>
	</div>
</template>


<script>
import Swal from 'sweetalert2';
import ProductoInfo from './cardContent/producto/ProductoInfo.vue';
import { mapState, mapActions } from 'vuex';

export default {
	name: "CardCatalogo",
	props: [
		"title",
		"content",
		"cardClass",
		"cardSize",
		"headerClass",
		"index",
		"lastIndex",
		'user'
	],
	components: {
		ProductoInfo
	},
	data() {

		return {
			animate: false,
			imageSrc: ``,
			altImageSrc: ``,
			showModal: false,
			inputValue: '',
			localCardClass: this.cardClass ?? '',
			localTitle: this.title ?? '',
			localIndex: this.index ?? 0,
			localHeaderClass: this.headerClass ?? '',
			localContent: { ...this.content },
		};
	},
	computed: {
		...mapState("orders", ["cartItems", "cartItemsQuantity"]),
		hayEtiquetasActivas() {
			return (
				((100 - this.content.total_indexado) > 0 && this.content.desc_indexados) ||
				(this.localContent.iva > 0) ||
				(this.localContent.discountMarca > 0) ||
				(this.localContent.discountItem > 0)
			);
		}

	},
	methods: {
		...mapActions("orders", ["addToCart", "fetchCartItemsQuantity"]),
		focusOnInput() {
			const inputElement = this.$el.querySelector('input');
			if (inputElement) {
				setTimeout(() => {
					inputElement.focus();
				}, 300);
			}
		},
		handleSedesStatus({ item, barra }) {
			this.$functions.modals.openSedesStatusModal(
				this.$axios,
				this.$apiRoute,
				{ item, barra }
			);
		},
		toggleAnimation() {
			this.animate = true;
			setTimeout(() => {
				this.animate = false;
			}, 1500);
		},
		showSweetAlert(obj) {
			Swal.fire(obj);
		},
		closeModal() {
			this.showModal = false;
		},
		updateValue(item) {
			this.inputValue = item;
		},
		truncatedValue(value) {
			const val = String(value);
			return val.length > 30 ? val.substring(0, 30) + '…' : val;
		},
		handleCart(product) {
			// Get the input value (quantity)
			this.toggleAnimation();
			const quantity = parseFloat(this.inputValue);
			// Check if the input value is less than or equal to 0
			if (isNaN(quantity) || quantity <= 0) {
				// Show an alert to the user
				let obj = {
					title: 'Ups!!!',
					text: 'La cantidad ingresada debe ser mayor a 0',
					icon: 'error',
					confirmButtonText: 'OK',
					customClass: {
						confirmButton: 'custom-confirm-button', // Apply the custom class to the confirm button
					},
				}
				this.showSweetAlert(obj)
				return; // Exit the function to prevent adding the product to the cart
			}

			// Dispatch the addToCart action to add the product to the cart in the Vuex store
			const productToAdd = {
				...product,
				quantity,
			};

			this.addToCart({
				axios: this.$axios,
				apiRoute: this.$apiRoute,
				router: this.$router,
				data: productToAdd
			}).then(() => {
				// After adding the product to the cart, fetch the updated cart items quantity
				this.fetchCartItemsQuantity({
					axios: this.$axios,
					apiRoute: this.$apiRoute,
				}).then(() => {
					// Once the cart items quantity is updated, commit a mutation to update it in the state
					this.$store.commit('orders/updateCartItemsQuantity', this.cartItemsQuantity);
				});
			});
		},
		tooltipHtml(content) {
			let html = ``;
			if (content.desc_indexados) {
				try {
					html += `<ul>`
					let descuentos = JSON.parse(content.desc_indexados);
					descuentos.map((item) => {
						html += `<li>${item.description}: ${item.amountWithoutPercentOri}%</li>`
					})

					html += `</ul>`
				} catch (err) {
					console.log(err);
				}
			}

			html += `<hr><h1>Total: ${content.total_indexado}%</h1>`;
			return html;
		}
	},
	watch: {
		"content.barra": function () {
			this.imageSrc = `${this.$imgProdUrl}/${this.content.barra}.jpg`;
			this.altImageSrc = `${this.$imgProdUrl}/noimagen.jpg`;
		},

		"content": function () {
			this.localContent = {
				...this.content
			}
		},

		showModal(newVal) {
			console.log("showModal changed:", newVal);
		},
	},
	mounted() {
		// Find the corresponding cart item and update the quantity in the local copy

		(this.imageSrc = `${this.$imgProdUrl}/${this.content.barra}.jpg`),
			(this.altImageSrc = `${this.$imgProdUrl}/noimagen.jpg`);
	},
};
</script>

<style scoped>
.product-image {
	transition: transform 0.3s;
}

.product-image:hover {
	transform: scale(1.2);
	z-index: 99;
	box-shadow: 5px 5px 20px rgba(0, 0, 0, 0.6);
	position: relative;
}

.badge {
	font-size: 0.75rem;

	/* text-xs */
	@media (min-width: 640px) {
		font-size: 0.875rem;
		/* sm:text-sm */
	}

	color: #fff;
	/* text-white */
	font-weight: 600;
	/* font-semibold */
	border-radius: 0.25rem;
	/* rounded */
	padding-left: 0.5rem;
	/* px-2 */
	padding-right: 0.5rem;
	/* px-2 */
	padding-top: 0.125rem;
	/* py-0.5 */
	padding-bottom: 0.125rem;
	/* py-0.5 */
	display: flex;
	/* flex */
	align-items: center;
	/* items-center */
}
</style>
